(function(){
    'use strict'

    angular
    .module('app.tiposAccionPersonal')
    .controller('TiposAccionPersonal', TiposAccionPersonal);

    TiposAccionPersonal.$inject = ['$animationsSrv', 'TiposAccionPersonalService', 'logger', '$location', 'UserInfoService'];

    function TiposAccionPersonal($animationsSrv, TiposAccionPersonalService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.tiposAccionPersonal = [];
        vm.title = 'Tipos de Acción de Personal';

        vm.goToEdit = function(tipoAccionPersonal){
            
            var path = '/editar-tipo-accion-personal/';

            if(tipoAccionPersonal){
                $location.path(path + tipoAccionPersonal.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){

            var promise = TiposAccionPersonalService.getAll(UserInfoService.getCompaniaId());

            promise
            .then(function(tiposAccionPersonal){
                vm.tiposAccionPersonal = tiposAccionPersonal;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los tipos de Acción de Personal.');
                        break;
                }
                
            });
        };

        vm.delete = function(tipoAccionPersonal){
            var promise = TiposAccionPersonalService.remove(tipoAccionPersonal);
            
            promise
            .then(function(response){
                vm.tiposAccionPersonal = vm.tiposAccionPersonal.filter(function(u) {
                    return u.id !== tipoAccionPersonal.id;
                });
                logger.success('Tipo de Acción de Personal eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el tipo de Acción de Personal');
                        break;
                }
                
            });   
        };

    }
})();